// Shim. The validation editor moved to the shared package
// (@twasta/page-runtime/designerKit), where it reads master tables, columns,
// project variables and IOFlow APIs from an injected DesignerCatalog. This
// wrapper supplies the builder's catalog (./designerCatalog), so every importer
// keeps its props and behaviour.
import type { ComponentProps } from 'react'
import { ValidationRuleEditor as KitValidationRuleEditor } from '@twasta/page-runtime/designerKit'
import { usePlatformDesignerCatalog } from './designerCatalog'

type Props = Omit<ComponentProps<typeof KitValidationRuleEditor>, 'catalog'>

export default function ValidationRuleEditor(props: Props) {
  const { catalog, confirmDialog } = usePlatformDesignerCatalog(props.project)
  return (
    <>
      <KitValidationRuleEditor {...props} catalog={catalog} />
      {confirmDialog}
    </>
  )
}
